"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSyncQueueList = void 0;
const react_1 = require("react");
const context_1 = require("../context");
const utils_1 = require("../utils");
const useDebouncedAbortableCall_1 = require("./useDebouncedAbortableCall");
const useSyncQueueList = (params) => {
    const { selectedOrgUser } = (0, react_1.useContext)(context_1.OrganizationContext);
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const [refreshKey, setRefreshKey] = (0, react_1.useState)(0);
    const [syncQueue, setSyncQueue] = (0, react_1.useState)({ items: [] });
    const fetchSyncQueue = (0, useDebouncedAbortableCall_1.useDebouncedAbortableCall)((abortContext, selectedOrgUser, params) => __awaiter(void 0, void 0, void 0, function* () {
        yield selectedOrgUser.syncQueueManager.fetchSyncQueue(params, abortContext);
        setSyncQueue(selectedOrgUser.syncQueueManager.syncQueueData);
    }), utils_1.Constants.API_DEBOUNCE_DELAY_IN_MS);
    const refetch = (0, react_1.useCallback)(() => setRefreshKey(key => key + 1), []);
    (0, react_1.useEffect)(() => {
        (() => __awaiter(void 0, void 0, void 0, function* () {
            if (selectedOrgUser) {
                try {
                    setIsLoading(true);
                    yield fetchSyncQueue(selectedOrgUser, params);
                }
                finally {
                    setIsLoading(false);
                }
            }
        }))();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [params, selectedOrgUser, refreshKey]);
    return {
        syncQueue,
        isLoading,
        refetch,
    };
};
exports.useSyncQueueList = useSyncQueueList;
